import Axios from "axios";
//dev
Axios.defaults.baseURL = "https://lms-back-end-ct-svqu.onrender.com/api";

Axios.defaults.withCredentials = true;

// Add request interceptor to always use the latest token
Axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle 401 errors globally
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/StudentLogin";
    }
    return Promise.reject(error);
  }
);

export default class AxiosServices {
  post(url, data, Header = false) {
    const headers = Header || {};
    return Axios.post(url, data, { headers });
  }

  get(url, header = null) {
    const headers = header || {};
    return Axios.get(url, { headers });
  }

  put(url, data, Header = false) {
    const headers = Header || {};
    return Axios.put(url, data, { headers });
  }

  delete(url, Header = false) {
    const headers = Header || {};
    return Axios.delete(url, { headers });
  }
}
